/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: uw79hRWChb6G

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFeaturesTopSection.module.css"; // plasmic-import: uw79hRWChb6G/css

createPlasmicElementProxy;

export type PlasmicFeaturesTopSection__VariantMembers = {};
export type PlasmicFeaturesTopSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesTopSection__VariantsArgs;
export const PlasmicFeaturesTopSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFeaturesTopSection__ArgsType = {};
type ArgPropType = keyof PlasmicFeaturesTopSection__ArgsType;
export const PlasmicFeaturesTopSection__ArgProps = new Array<ArgPropType>();

export type PlasmicFeaturesTopSection__OverridesType = {
  top?: Flex__<"section">;
  banner?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  col?: Flex__<"div">;
  sectionHeader?: Flex__<"header">;
  top2?: Flex__<"div">;
  subtitle?: Flex__<"h4">;
  title?: Flex__<"h1">;
  img?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultFeaturesTopSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesTopSection__RenderFunc(props: {
  variants: PlasmicFeaturesTopSection__VariantsArgs;
  args: PlasmicFeaturesTopSection__ArgsType;
  overrides: PlasmicFeaturesTopSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"top"}
      data-plasmic-override={overrides.top}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.top
      )}
    >
      <div
        data-plasmic-name={"banner"}
        data-plasmic-override={overrides.banner}
        className={classNames(projectcss.all, sty.banner)}
      >
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          className={classNames(projectcss.all, sty.wrapper)}
        >
          <div
            data-plasmic-name={"col"}
            data-plasmic-override={overrides.col}
            className={classNames(projectcss.all, sty.col)}
          >
            <header
              data-plasmic-name={"sectionHeader"}
              data-plasmic-override={overrides.sectionHeader}
              className={classNames(projectcss.all, sty.sectionHeader)}
            >
              <div
                data-plasmic-name={"top2"}
                data-plasmic-override={overrides.top2}
                className={classNames(projectcss.all, sty.top2)}
              >
                <h4
                  data-plasmic-name={"subtitle"}
                  data-plasmic-override={overrides.subtitle}
                  className={classNames(
                    projectcss.all,
                    projectcss.h4,
                    projectcss.__wab_text,
                    sty.subtitle
                  )}
                >
                  {"Features"}
                </h4>
                <h1
                  data-plasmic-name={"title"}
                  data-plasmic-override={overrides.title}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.title
                  )}
                >
                  {"Feature Showcase for Enhanced Medical Education"}
                </h1>
              </div>
            </header>
          </div>
        </div>
      </div>
      <PlasmicImg__
        data-plasmic-name={"img"}
        data-plasmic-override={overrides.img}
        alt={""}
        className={classNames(sty.img)}
        displayHeight={
          hasVariant(globalVariants, "mobile", "mobile")
            ? "auto"
            : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? "auto"
              : "482px"
        }
        displayMaxHeight={"none"}
        displayMaxWidth={"none"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant(globalVariants, "mobile", "mobile")
            ? "773.72px"
            : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? "1024px"
              : "1640px"
        }
        loader={"plasmic"}
        loading={"lazy"}
        src={
          hasVariant(globalVariants, "mobile", "mobileXSmall")
            ? {
                src: "https://img.plasmic.app/img-optimizer/v1/img/cca9ce405824f40fd6314526b305f6f9.png",
                fullWidth: 1548,
                fullHeight: 720
              }
            : hasVariant(globalVariants, "mobile", "mobile")
              ? {
                  src: "https://img.plasmic.app/img-optimizer/v1/img/cca9ce405824f40fd6314526b305f6f9.png",
                  fullWidth: 1548,
                  fullHeight: 720
                }
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? {
                    src: "https://img.plasmic.app/img-optimizer/v1/img/cca9ce405824f40fd6314526b305f6f9.png",
                    fullWidth: 1548,
                    fullHeight: 720
                  }
                : {
                    src: "https://img.plasmic.app/img-optimizer/v1/img/658a22964ed8fc56caf7545f036ef9e1.png",
                    fullWidth: 1640,
                    fullHeight: 482
                  }
        }
      />
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  top: [
    "top",
    "banner",
    "wrapper",
    "col",
    "sectionHeader",
    "top2",
    "subtitle",
    "title",
    "img"
  ],
  banner: [
    "banner",
    "wrapper",
    "col",
    "sectionHeader",
    "top2",
    "subtitle",
    "title"
  ],
  wrapper: ["wrapper", "col", "sectionHeader", "top2", "subtitle", "title"],
  col: ["col", "sectionHeader", "top2", "subtitle", "title"],
  sectionHeader: ["sectionHeader", "top2", "subtitle", "title"],
  top2: ["top2", "subtitle", "title"],
  subtitle: ["subtitle"],
  title: ["title"],
  img: ["img"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  top: "section";
  banner: "div";
  wrapper: "div";
  col: "div";
  sectionHeader: "header";
  top2: "div";
  subtitle: "h4";
  title: "h1";
  img: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesTopSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesTopSection__VariantsArgs;
    args?: PlasmicFeaturesTopSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesTopSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesTopSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesTopSection__ArgProps,
          internalVariantPropNames: PlasmicFeaturesTopSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesTopSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "top") {
    func.displayName = "PlasmicFeaturesTopSection";
  } else {
    func.displayName = `PlasmicFeaturesTopSection.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesTopSection = Object.assign(
  // Top-level PlasmicFeaturesTopSection renders the root element
  makeNodeComponent("top"),
  {
    // Helper components rendering sub-elements
    banner: makeNodeComponent("banner"),
    wrapper: makeNodeComponent("wrapper"),
    col: makeNodeComponent("col"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    top2: makeNodeComponent("top2"),
    subtitle: makeNodeComponent("subtitle"),
    title: makeNodeComponent("title"),
    img: makeNodeComponent("img"),

    // Metadata about props expected for PlasmicFeaturesTopSection
    internalVariantProps: PlasmicFeaturesTopSection__VariantProps,
    internalArgProps: PlasmicFeaturesTopSection__ArgProps
  }
);

export default PlasmicFeaturesTopSection;
/* prettier-ignore-end */
